<template>
  <div>
    <div>
      <div class="registration-head text-center" style="background:#006C6B">
        <div class="sml-container">
          <div class="rg-head">
            <h1>入力内容確認</h1>
          </div>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec">
          <div class="career-rgst">
            <img src="../assets/NewLogo.svg" />
          </div>
          <div class="mt-5 ml-auto mr-auto" style="width: 100%">
            <h5>入力内容をご確認ください</h5>
          </div>
          <div class="rgst-dtl-sec">
            <BProfilePreview :registrationEndpoint="'bloomRegister'" @redirectToRegistrationPage="redirectToRegistrationPage"/>
          </div>
          <!-- ends rgst-dtl-sec -->
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from "vuex";
import BProfilePreview from "./BProfilePreview.vue";

export default {
  name: "profilePreview",
  components: { BProfilePreview },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({
      setBloomData: "setBloomData",
    }),
    redirectToRegistrationPage() {
      this.$router.push({
        name: "bloomRegistration",
        // params: { slug: this.$route.params.slug }
      });
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    await this.setBloomData(true);
    // this.photoPreview();
    // const check = await this.checkCompany(this.$route.params.slug);
    // if (!check) this.$router.push({ name: "Maintenance" });
  },
};
</script>
